import React from 'react';
import PostPage from '../components/post';

const Post = () => <PostPage />;

export default Post;
